(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var navButton = document.querySelector('.sa-nav-toggle');
    var nav = document.getElementById('sa-site-nav');

    if (navButton && nav) {
      navButton.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        navButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        navButton.textContent = open ? 'Close' : 'Menu';
      });
    }

    document.querySelectorAll('[data-copy-keyword]').forEach(function (button) {
      button.addEventListener('click', function () {
        var keyword = button.getAttribute('data-copy-keyword');
        var done = function () {
          button.textContent = 'Copied';
          window.setTimeout(function () { button.textContent = 'Copy'; }, 1500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(keyword).then(done).catch(function () {});
        }
      });
    });

    var contactTool = document.getElementById('sa-contact-tool');
    if (contactTool) {
      var reference = '';
      var stateSelect = document.getElementById('sa-contact-state');
      var typeSelect = document.getElementById('sa-contact-type');
      var otherInput = document.getElementById('sa-contact-other');
      var otherBox = document.getElementById('sa-contact-other-box');
      var checkButton = document.getElementById('sa-contact-check');

      function businessType() {
        return typeSelect.value === '__other' ? otherInput.value.trim() : typeSelect.value;
      }

      function contactIntent() {
        var selected = contactTool.querySelector('input[name="contact[intent]"]:checked');
        return selected ? selected.value : 'The free market read for now';
      }

      function auditRequested() {
        return contactIntent().indexOf('full audit') !== -1;
      }

      function updateContactResponse() {
        var audit = auditRequested();
        contactTool.querySelectorAll('[data-contact-response-copy]').forEach(function (element) {
          element.textContent = audit
            ? "We'll contact you within 24 hours to go through scope and pricing."
            : "We'll send your market read in three to five business days.";
        });
        contactTool.querySelectorAll('[data-contact-response]').forEach(function (element) {
          element.textContent = audit ? 'Within 24 hours' : 'Three to five business days';
        });
        contactTool.querySelectorAll('[data-contact-confirmation-copy]').forEach(function (element) {
          element.textContent = audit
            ? "We'll contact you within 24 hours to go through scope and pricing."
            : "We'll send your market read in three to five business days. No meeting is required to receive it.";
        });
      }

      function refreshContactButton() {
        checkButton.disabled = !(stateSelect.value && businessType());
      }

      function showContactStep(number) {
        contactTool.querySelectorAll('[data-contact-step]').forEach(function (step) {
          step.classList.toggle('is-on', step.getAttribute('data-contact-step') === String(number));
        });
        document.getElementById('lookup').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function stampContact(label) {
        contactTool.querySelectorAll('[data-contact-market]').forEach(function (element) { element.textContent = label; });
        contactTool.querySelectorAll('[data-contact-ref]').forEach(function (element) { element.textContent = 'REF ' + reference; });
      }

      function rememberContactConfirmation(market) {
        try {
          window.sessionStorage.setItem('searchacre-contact-confirmation', JSON.stringify({ market: market, reference: reference, intent: contactIntent() }));
        } catch (error) {}
      }

      function restoreContactConfirmation() {
        try {
          var saved = JSON.parse(window.sessionStorage.getItem('searchacre-contact-confirmation'));
          if (!saved) return;
          reference = saved.reference || '';
          if (saved.intent) {
            contactTool.querySelectorAll('input[name="contact[intent]"]').forEach(function (input) {
              input.checked = input.value === saved.intent;
            });
          }
          stampContact(saved.market || 'MARKET REQUEST');
          updateContactResponse();
        } catch (error) {}
      }

      stateSelect.addEventListener('change', refreshContactButton);
      typeSelect.addEventListener('change', function () {
        otherBox.hidden = typeSelect.value !== '__other';
        refreshContactButton();
      });
      otherInput.addEventListener('input', refreshContactButton);
      contactTool.querySelectorAll('input[name="contact[intent]"]').forEach(function (input) {
        input.addEventListener('change', updateContactResponse);
      });

      checkButton.addEventListener('click', function () {
        reference = String(Math.floor(Math.random() * 9000) + 1000);
        stampContact((stateSelect.value + ' · ' + businessType()).toUpperCase());
        updateContactResponse();
        showContactStep(2);
        document.getElementById('sa-contact-city').focus();
      });

      document.getElementById('sa-contact-city').addEventListener('blur', function () {
        var city = this.value.trim();
        if (city) stampContact((city + ' · ' + businessType()).toUpperCase());
      });

      contactTool.addEventListener('submit', function (event) {
        var city = document.getElementById('sa-contact-city').value.trim();
        var email = document.getElementById('sa-contact-email').value.trim();
        var phone = document.getElementById('sa-contact-phone').value.trim();
        var cityError = document.getElementById('sa-contact-city-error');
        var methodError = document.getElementById('sa-contact-method-error');
        cityError.classList.toggle('is-on', !city);
        methodError.classList.toggle('is-on', !email && !phone);
        if (!city || (!email && !phone)) {
          event.preventDefault();
          return;
        }

        document.getElementById('sa-contact-route-email').value = email || 'phone-only@searchacre.com';
        document.getElementById('sa-contact-reference').value = reference;
        rememberContactConfirmation((city + ' · ' + businessType()).toUpperCase());
        document.getElementById('sa-contact-body').value = [
          auditRequested() ? 'LEAD TYPE: FULL AUDIT' : 'LEAD TYPE: FREE MARKET READ',
          'Reference: ' + reference,
          'State: ' + stateSelect.value,
          'City: ' + city,
          'Business type: ' + businessType(),
          'Request: ' + contactIntent(),
          'Name: ' + document.getElementById('sa-contact-name').value.trim(),
          'Business: ' + document.getElementById('sa-contact-business').value.trim(),
          'Customer email: ' + (email || 'Not provided'),
          'Phone: ' + (phone || 'Not provided'),
          'Website or TikTok: ' + (document.getElementById('sa-contact-web').value.trim() || 'Not provided'),
          'SMS consent: ' + (document.getElementById('sa-contact-sms').checked ? 'Yes' : 'No')
        ].join('\n');
        var sendButton = document.getElementById('sa-contact-send');
        sendButton.disabled = true;
        sendButton.textContent = 'Sending…';
      });

      var contactPostedMarker = contactTool.querySelector('[data-contact-posted-successfully]');
      var contactPosted = contactPostedMarker && contactPostedMarker.getAttribute('data-contact-posted-successfully') === 'true';
      if (contactPosted || new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
        if (!window.sessionStorage.getItem('searchacre-complete-registration-tracked-v4')) {
          var completeRegistrationAttempts = 0;
          var completeRegistrationTimer = window.setInterval(function () {
            completeRegistrationAttempts += 1;
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'CompleteRegistration');
              window.sessionStorage.setItem('searchacre-complete-registration-tracked-v4', 'true');
              window.clearInterval(completeRegistrationTimer);
            } else if (completeRegistrationAttempts >= 40) {
              window.clearInterval(completeRegistrationTimer);
            }
          }, 250);
        }
        restoreContactConfirmation();
        showContactStep(3);
      }
    }

    var setupTool = document.getElementById('sa-setup-tool');
    if (setupTool) {
      var setupReference = '';
      var setupCity = document.getElementById('sa-setup-city');
      var setupTrade = document.getElementById('sa-setup-trade');

      function showSetupStep(number) {
        setupTool.querySelectorAll('[data-setup-step]').forEach(function (step) {
          step.classList.toggle('is-on', step.getAttribute('data-setup-step') === String(number));
        });
        document.getElementById('territory').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function stampSetup() {
        var label = (setupCity.value.trim() + ' / ' + setupTrade.value).toUpperCase();
        setupTool.querySelectorAll('[data-setup-market]').forEach(function (element) { element.textContent = label; });
        setupTool.querySelectorAll('[data-setup-ref]').forEach(function (element) { element.textContent = 'REF ' + setupReference; });
      }

      function rememberSetupConfirmation() {
        try {
          window.sessionStorage.setItem('searchacre-setup-confirmation', JSON.stringify({ market: (setupCity.value.trim() + ' / ' + setupTrade.value).toUpperCase(), reference: setupReference }));
        } catch (error) {}
      }

      function restoreSetupConfirmation() {
        try {
          var saved = JSON.parse(window.sessionStorage.getItem('searchacre-setup-confirmation'));
          if (!saved) return;
          setupReference = saved.reference || '';
          setupTool.querySelectorAll('[data-setup-market]').forEach(function (element) { element.textContent = saved.market || 'MARKET REQUEST'; });
          setupTool.querySelectorAll('[data-setup-ref]').forEach(function (element) { element.textContent = 'REF ' + setupReference; });
        } catch (error) {}
      }

      document.getElementById('sa-setup-check').addEventListener('click', function () {
        var valid = setupCity.value.trim() && setupTrade.value;
        document.getElementById('sa-setup-start-error').classList.toggle('is-on', !valid);
        if (!valid) return;
        setupReference = String(Math.floor(Math.random() * 9000) + 1000);
        stampSetup();
        showSetupStep(2);
      });

      setupTool.addEventListener('submit', function (event) {
        var email = document.getElementById('sa-setup-email').value.trim();
        var phone = document.getElementById('sa-setup-phone').value.trim();
        var error = document.getElementById('sa-setup-contact-error');
        error.classList.toggle('is-on', !email && !phone);
        if (!email && !phone) {
          event.preventDefault();
          return;
        }

        document.getElementById('sa-setup-route-email').value = email || 'phone-only@searchacre.com';
        document.getElementById('sa-setup-reference').value = setupReference;
        rememberSetupConfirmation();
        document.getElementById('sa-setup-body').value = [
          'LEAD TYPE: FREE MARKET READ — SETUP PAGE',
      'SearchAcre setup territory request',
          'Reference: ' + setupReference,
          'City: ' + setupCity.value.trim(),
          'Trade: ' + setupTrade.value,
          'Name: ' + document.getElementById('sa-setup-name').value.trim(),
          'Business: ' + document.getElementById('sa-setup-business').value.trim(),
          'Customer email: ' + (email || 'Not provided'),
          'Phone: ' + (phone || 'Not provided'),
          'Website or TikTok: ' + (document.getElementById('sa-setup-web').value.trim() || 'Not provided')
        ].join('\n');
        var sendButton = document.getElementById('sa-setup-send');
        sendButton.disabled = true;
        sendButton.textContent = 'Sending…';
      });

      var setupPostedMarker = setupTool.querySelector('[data-setup-posted-successfully]');
      var setupPosted = setupPostedMarker && setupPostedMarker.getAttribute('data-setup-posted-successfully') === 'true';
      if (setupPosted || new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
        restoreSetupConfirmation();
        showSetupStep(3);
      }
    }
  });
})();
